// @mui material components
import Card from "@mui/material/Card";

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";

import CoverLayout from "layouts/authentication/components/CoverLayout";
import { useState } from "react";
import { resetPassword } from "../../../../services/authService";
import buildingWindowsImage from "assets/images/building-windows.svg";
import { useNavigate } from "react-router-dom";
import { emailRegex } from "services/utilities";
import { toast } from "react-toastify";

function Cover() {
  const [email, setEmail] = useState();
  const navigate = useNavigate();
  const handleReset = () => {
    if (!email) {
      toast.error("Email required");
      return;
    }

    if (!emailRegex.test(email)) {
      toast.error("Invalid email");
      return;
    }

    resetPassword(email)
      .then((data) => {
        toast.success("Check your inbox for OTP");
        navigate(`/user/email-verification?email=${encodeURIComponent(email)}`);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Something went wrong");
      });
  };

  return (
    <CoverLayout
      image={buildingWindowsImage}
      imgPosition="top"
      button={{ color: "info" }}
    >
      <Card sx={{ minWidth: "440px", minHeight: "340px" }}>
        <ArgonBox p={3}>
          <ArgonBox display="flex" alignItems="center">
            <ArgonBox
              width="3rem"
              height="3rem"
              bgColor="#5ad1c4"
              shadow="md"
              display="grid"
              alignItems="center"
              justifyContent="center"
              borderRadius="md"
            >
              <ArgonBox
                component="i"
                color="white"
                fontSize="2rem"
                className="ni ni-circle-08"
              />
            </ArgonBox>
            <ArgonBox ml={2} lineHeight={1}>
              <ArgonTypography variant="h5" color="dark">
                Can&apos;t log in?
              </ArgonTypography>
              <ArgonTypography variant="button" fontWeight="regular">
                Restore access to your account
              </ArgonTypography>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
        <ArgonBox p={3}>
          <ArgonBox component="form" role="form">
            <ArgonBox mb={2}>
              <ArgonTypography
                display="block"
                variant="caption"
                color="dark"
                sx={{ ml: 0.5, mb: 1 }}
              >
                We will send a recovery code to
              </ArgonTypography>
              <ArgonInput
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </ArgonBox>
            <ArgonBox mt={3} mb={1} textAlign="center">
              <ArgonButton color="primary" fullWidth onClick={handleReset}>
                Send Recovery Code
              </ArgonButton>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
